import {PersonDto} from "./person.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";

// TYPE ONLY: ad is a foreign module here, and this DTO only needs the SHAPE of the resolved sub-DTO
// - the rows themselves are always fetched through MvsCoreService.getCrudService('pm.PersonAddress').
// (cr's CustomerAddressDto imports Address as a VALUE on purpose, because it instantiates
// `new Address()` for the nested-create payload; nothing in pm does.)
import type {Address} from "../../../../../feature-core/ad/model/dto/entity/address";

export class PersonAddressDto extends DtoDetail{


    public personDto? : PersonDto;
    public personDtoId : number;
    public personDtoName : string;

    /**
     * The resolved ad.Address of this assignment - filled by a depth-2 ObjectRequestComplex
     * ("address" -> "addressType"). Without this field the depth-2 response arrives untyped.
     * Mirrors CustomerAddressDto.addressDto.
     */
    public addressDto? : Address;
    public addressDtoId : number;
    public addressDtoName : string;
    public entityStatus: EntityStatusEnum;
    public startDate: Date;
    public endDate: Date;

}